<template>
  <v-layout row>
    <v-btn v-if="user && isCommunityJoined" dark fab right color="teal" slot="activator"
           style="bottom: 30px; right:10px; position: fixed; z-index: 1">
      <v-icon>add</v-icon>
    </v-btn>
    <v-flex>
      <v-card style="min-height: 680px">
        <v-container>
          <v-sheet height="500" class="mt-3">
            <v-sheet height="60" class="headline font-weight-bold text-xs-center">
              <v-btn fab outline small absolute left color="teal" @click="$refs.calendar.prev()">
                <v-icon dark>
                  keyboard_arrow_left
                </v-icon>
              </v-btn>
              {{ start | moment("MMMM YYYY") }}
              <v-btn fab outline small absolute right color="teal" @click="$refs.calendar.next()">
                <v-icon dark>
                  keyboard_arrow_right
                </v-icon>
              </v-btn>
            </v-sheet>
            <v-calendar ref="calendar" v-model="start" color="teal"
              v-touch="{ right: () => $refs.calendar.prev(), left: () => $refs.calendar.next(),}">
              <template slot="day" slot-scope="{ date }">
                <template v-for="event in eventsMap[date]">
                  <v-menu :key="event.title" v-model="event.open" full-width offset-x>
                    <div v-if="!event.time" slot="activator" v-ripple class="my-event"
                         v-html="event.title"></div>
                    <v-card color="grey lighten-4" min-width="350px" flat>
                      <v-toolbar color="teal" dark>
                        <v-btn icon>
                          <v-icon>edit</v-icon>
                        </v-btn>
                        <v-toolbar-title v-html="event.title"></v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn icon>
                          <v-icon>favorite</v-icon>
                        </v-btn>
                        <v-btn icon>
                          <v-icon>more_vert</v-icon>
                        </v-btn>
                      </v-toolbar>
                      <v-card-title primary-title>
                        <span v-html="event.details"></span>
                      </v-card-title>
                      <v-card-actions>
                        <v-btn
                          flat
                          color="secondary"
                        >
                          Cancel
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-menu>
                </template>
              </template>
           </v-calendar>
          </v-sheet>
        </v-container>
      </v-card>
    </v-flex>

    <v-dialog v-model="drawer" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark color="teal">
          <v-btn icon dark @click="drawer = false">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>New Chat</v-toolbar-title>
        </v-toolbar>
        <v-form>
          <v-container>
            <v-layout wrap>
              <v-flex xs12 text-xs-center>
                <v-btn
                       color="teal white--text">
                  GO TO CHAT
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card>
    </v-dialog>

  </v-layout>
</template>

<script>
export default {
  name: 'EventSpace',
  props: {
    user: Object,
    communityId: String,
    isCommunityJoined: Boolean,
  },
  data() {
    return {
      drawer: false,
      start: new Date(),
      // end: '2019-02-06',
      events: {
        'kojin-dev': [
          // {
          //   title: 'Vacation',
          //   details: 'Going to the beach!',
          //   date: '2019-01-30',
          //   open: false,
          // },
          // {
          //   title: 'Vacation',
          //   details: 'Going to the beach!',
          //   date: '2019-01-31',
          //   open: false,
          // },
          // {
          //   title: 'Vacation',
          //   details: 'Going to the beach!',
          //   date: '2019-02-01',
          //   open: false,
          // },
          // {
          //   title: 'Meeting',
          //   details: 'Spending time on how we do not have enough time',
          //   date: '2019-02-07',
          //   open: false,
          // },
          // {
          //   title: '30th Birthday',
          //   details: 'Celebrate responsibly',
          //   date: '2019-02-03',
          //   open: false,
          // },
          // {
          //   title: 'New Year',
          //   details: 'Eat chocolate until you pass out',
          //   date: '2019-02-01',
          //   open: false,
          // },
          // {
          //   title: 'Conference',
          //   details: 'Mute myself the whole time and wonder why I am on this call',
          //   date: '2019-02-21',
          //   open: false,
          // },
          {
            title: 'kojin-dev meetup #1',
            details: '個人開発者同士の集まり第1弾として、オフ会を開催します！',
            date: '2019-03-01',
            open: false,
            topicId: 'BlTWBUrlZqQD17Lq2txI',
          },
          {
            title: 'kojin-dev meetup #2',
            details: '個人開発者同士の集まり第2弾として、オフ会を開催します！',
            date: '2019-04-12',
            open: false,
            topicId: '6n5gPr2V75jHAAUYRSHd',
          },
        ],
      },
      items: [
        { title: 'Home', icon: 'dashboard' },
        { title: 'About', icon: 'question_answer' },
      ],
    };
  },
  computed: {
    // convert the list of events into a map of lists keyed by date
    eventsMap() {
      const map = {};
      if (this.events[this.communityId]) this.events[this.communityId].forEach(e => (map[e.date] = map[e.date] || []).push(e));
      return map;
    },
  },
  methods: {
    open(event) {
      alert(event.title);
    },
  },
};
</script>

<style lang="stylus" scoped>
  .my-event {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    border-radius: 2px;
    background-color: #009688;
    color: #ffffff;
    border: 1px solid #009688;
    width: 100%;
    font-size: 12px;
    padding: 3px;
    cursor: pointer;
    margin-bottom: 1px;
  }
  .v-navigation-drawer--temporary {
    z-index 2000;
  }
</style>
